import { Routes, Route, Navigate } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Dashboard } from './pages/Dashboard';
import { MyAlbum } from './pages/MyAlbum';
import { Missing } from './pages/Missing';
import { Duplicates } from './pages/Duplicates';
import { Matches } from './pages/Matches';
import { Trades } from './pages/Trades';
import { Upload } from './pages/Upload';
import { UploadLoose } from './pages/UploadLoose';
import { ManualEntry } from './pages/ManualEntry';
import { Settings } from './pages/Settings';
import { PublicCollection } from './pages/PublicCollection';
import { AppShell } from './components/AppShell';
import { useAuth } from './hooks/useAuth';

function Protected({ children }: { children: JSX.Element }) {
  const { token } = useAuth();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/u/:slug" element={<PublicCollection />} />

      <Route
        element={
          <Protected>
            <AppShell />
          </Protected>
        }
      >
        <Route path="/app" element={<Dashboard />} />
        <Route path="/app/album" element={<MyAlbum />} />
        <Route path="/app/missing" element={<Missing />} />
        <Route path="/app/duplicates" element={<Duplicates />} />
        <Route path="/app/matches" element={<Matches />} />
        <Route path="/app/trades" element={<Trades />} />
        <Route path="/app/upload" element={<Upload />} />
        <Route path="/app/upload-loose" element={<UploadLoose />} />
        <Route path="/app/manual" element={<ManualEntry />} />
        <Route path="/app/settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
